import {endpoints} from './endpoints'
import request from '../request'

export function fileUpload(data, onUploadProgress = null) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.fileUpload,
			method: 'post',
			data,
			onUploadProgress,
			timeout: 3600000
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function normalizeZipFiles(files) {
	if (!Array.isArray(files)) return []

	return files
		.filter(Boolean)
		.map((item) => {
			if (!item || typeof item !== 'object') return item
			return item.file || item.attachment || item
		})
		.filter((file) => {
			if (!file) return false
			if (typeof file === 'string') return true
			return file.id || file.path || Object.prototype.hasOwnProperty.call(file, 'contents')
		})
}

export function getZippedFiles(data) {
	const requestData = {
		...data,
		files_to_zip: normalizeZipFiles(data && data.files_to_zip)
	}

	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getZippedFiles,
			method: 'post',
			data: requestData,
			timeout: 3600000
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getZippedFilesByItem(data) {
    return new Promise((resolve, reject) => {
        request({
            url: endpoints.getZippedFilesByItem,
            method: 'post',
            data,
            timeout: 3600000
        })
            .then(async function (response) {
                resolve(response)
            })
            .catch(function (error) {
                reject(error)
            })
    })
}